import { Entitlements, SET_ENTITLEMENTS } from './entitlementsConstants'

export const setEntitlements = (entitlements: Entitlements) => ({
  type: SET_ENTITLEMENTS,
  payload: entitlements,
})
